import { replace, toUpper } from 'ramda';
export var capitalize = replace(/^./, toUpper);
export var titleize = function titleize(string) {
  return string.split(' ').map(capitalize).join(' ');
};
export var startCase = function startCase(string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};